// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__YzZMk","dark":"BaseLayout_dark__HPo1K","light":"BaseLayout_light__XnnoM"};